import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import I18n from 'i18n'
import { initializeHighcharts, titleWithTooltip } from '../../../../common/Utils'
import GenericPlaceholder from '../../../../common/GenericPlaceholder'

const MultiDailySleepChart = props => {
  if (!props.dailyLogRows || props.dailyLogRows.length === 0) {
    return (
      <GenericPlaceholder title={I18n.t('components.dashboards.questionnaire.daily_sleep.title')} message={props.noDataMessage} />
    )
  }

  const allData = []
  for (const athleteSet of props.dailyLogRows) {
    const lineData = athleteSet.data.map(entry => {
      return {
        x: entry.date_only,
        y: entry.sleep_duration_num_moving_average,
        formatted_date: entry.formatted_date,
        sleep_duration: entry.sleep_duration
      }
    })
    allData.push({
      type: 'line',
      data: lineData,
      name: `${athleteSet.athlete.first_name} ${athleteSet.athlete.last_name}`,
      tooltip: {
        headerFormat: '',
        pointFormat: I18n.t('components.dashboards.questionnaire.daily_sleep.scatter.tooltip')
      }
    })
  }
  initializeHighcharts(true)
  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          title: titleWithTooltip(
            I18n.t('components.dashboards.questionnaire.daily_sleep.title'),
            I18n.t('components.dashboards.questionnaire.daily_sleep.info')
          ),
          subtitle: {
            text: I18n.t('components.dashboards.questionnaire.daily_sleep.subtitle')
          },
          series: allData,
          plotOptions: {
            line: {
              marker: {
                enabled: false
              }
            }
          },
          legend: {
            enabled: true
          },
          yAxis: {
            title: {
              text: I18n.t('components.dashboards.questionnaire.daily_sleep.yaxis')
            },
            min: 0
          },
          xAxis: {
            title: {
              text: ''
            },
            type: 'datetime',
            dateTimeLabelFormats: {
              day: '%d %b'
            }
          }
        }}
      />
    </>
  )
}

export default MultiDailySleepChart
